import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { ToggleSwitch } from 'wix-style-react'

const Container = styled.div`
  & > div > label {
    border: 1px solid #fff !important;
  }
  & > div > label > label {
    top: 0 !important;
  }
`

class ControlledToggleSwitch extends Component {

  constructor (props) {
    super(props)

    this.state = { isChecked: props.initialValue }
  }

  onChange = () => {
    this.setState({ isChecked: !this.state.isChecked }, () => this.props.onChange(this.state.isChecked))
  }

  render () {
    return (
      <Container>
        <ToggleSwitch size={this.props.size} checked={this.state.isChecked} onChange={this.onChange}>
          {this.props.children}
        </ToggleSwitch>
      </Container>
    )
  }
}

ControlledToggleSwitch.propTypes = {
  initialValue: PropTypes.bool,
  size: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}

export default ControlledToggleSwitch



// WEBPACK FOOTER //
// ./src/components/shared/ControlledToggleSwitch.js